import React, { useState } from 'react';
import { Box, Divider, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constants/url';

type FooterProps = {
  maxWidth?: number;
};

export default function Footer({ maxWidth = 1920 }: FooterProps) {
  const { t, i18n } = useTranslation(); // useTranslation 훅 사용
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'ko');
  const navigate = useNavigate();

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const selectedLanguage = event.target.value as string;
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage).then((r) => {
      localStorage.setItem('language', selectedLanguage); // 로컬 스토리지에 선택한 언어 저장

      window.dispatchEvent(new Event('storage'));
      // window.location.reload(); // 새로고침 호출(메뉴명 다국어 적용에 필요)
    }); // i18next의 언어 변경 메서드 호출
  };

  const handleGoToTermService = () => {
    navigate(ROUTES.TERM_SERVICE.path); // 이용약관 경로로 이동
  };
  const handleGoToPrivacyPolicy = () => {
    navigate(ROUTES.PRIVACY_POLICY.path); // 개인정보처리방침 경로로 이동
  };

  return (
    <Box width="100%" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
      <Divider variant="fullWidth" orientation="horizontal" flexItem />

      <Box minHeight="110px" width="100%" maxWidth={maxWidth || '1280px'} minWidth="320px" padding={1} paddingBottom={2}>
        <footer style={{ width: '100%' }}>
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" gap={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
              {/* 이용약관 */}
              <Typography
                variant="body2"
                onClick={handleGoToTermService}
                sx={{ cursor: 'pointer' }} // 클릭 커서
              >
                {t('footer.term')}
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ margin: '2px' }} />
              {/* 개인정보처리방침 */}
              <Typography
                variant="body2"
                onClick={handleGoToPrivacyPolicy}
                sx={{ cursor: 'pointer' }} // 클릭 커서
              >
                {t('footer.privacy')}
              </Typography>
            </Box>

            <Select
              labelId="language-select-label"
              id="language-select"
              value={language} // 현재 선택된 값
              variant="outlined"
              size="small"
              onChange={handleLanguageChange} // 값 변경 시 호출되는 핸들러
              sx={{
                width: '100px',
                fontSize: '12px'
              }}
            >
              <MenuItem value={'ko'} sx={{ fontSize: '12px' }}>
                KOR
              </MenuItem>
              <MenuItem value={'en'} sx={{ fontSize: '12px' }}>
                ENG
              </MenuItem>
              <MenuItem value={'ja'} sx={{ fontSize: '12px' }}>
                JPN
              </MenuItem>
            </Select>
          </Box>

          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            gap={{ xs: 0, sm: 1 }}
            alignItems={{ xs: 'start', sm: 'center' }}
            marginBottom={{ xs: 0.5, sm: 0 }}
          >
            <Typography variant="body2"> {t('footer.ulvac_korea')}</Typography>
            <Divider orientation="vertical" flexItem sx={{ margin: '2px' }} />
            <Typography variant="body2">{t('footer.business_registration_number')}</Typography>
          </Box>

          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            gap={{ xs: 0, sm: 1 }}
            alignItems={{ xs: 'start', sm: 'center' }}
            marginBottom={{ xs: 0.5, sm: 0 }}
          >
            <Typography variant="body2">{t('footer.address')}</Typography>
            <Divider orientation="vertical" flexItem sx={{ margin: '2px' }} />
            <Typography variant="body2">TEL: 031-683-2922</Typography>
            <Divider orientation="vertical" flexItem sx={{ margin: '2px' }} />
            <Typography variant="body2">FAX: 031-683-9034</Typography>
          </Box>

          <Typography variant="body2">{t('footer.copyright')}</Typography>
        </footer>
      </Box>
    </Box>
  );
}
